import type { TenantThemeConfig } from "@/config/themes/types";
import { THEME_MODE } from "@/constants";

export const lightThemeConfig: TenantThemeConfig = {
  id: THEME_MODE.LIGHT,
  mode: THEME_MODE.LIGHT,
  colors: {
    primary: "#0c2d16",
    primaryDark: "#222222",
    primaryLight: "#6A8C05",
    secondary: "#E8ECF1",
    accent: "#34E0C8",
    error: "#B42318",
    success: "#2ac3a2",
    warning: "#ffa436",
    info: "#2196F3",
    severityHigh: "#DC2626",
    severityMedium: "#EA580C",
    severityLow: "#CA8A04",
    background: "#F5F5F5",
    surface: "#FFFFFF",
    surfaceAlt: "#FAFAFA",
    surfaceRaised: "#FFFFFF",
    border: "#E0E0E0",
    sidebarBorder: "#8AAA8A",
    textPrimary: "#121212",
    textSecondary: "#656565",
    textDisabled: "#9E9E9E",
    textOnPrimary: "#FFFFFF",
    gradientBackground:
      "linear-gradient(135deg, #79A979 0%, #C1E0C1 15%, #E3F0E3 85%, #79A979 100%)",
    hoverPrimary: "#0a2412",
    hoverSecondary: "rgba(0, 0, 0, 0.04)",
    hoverTertiary: "rgba(0, 0, 0, 0.08)",
    surfaceHover: "rgba(0, 0, 0, 0.02)",
    chartPalette: ["#0c2d16", "#34E0C8", "#2ac3a2", "#2196F3", "#ffa436", "#6A8C05", "#79A979"],
  },
  overlay: {
    light05: "rgba(0, 0, 0, 0.05)",
    light10: "rgba(0, 0, 0, 0.10)",
    light20: "rgba(0, 0, 0, 0.20)",
    olive15: "rgba(57, 92, 60, 0.15)",
  },
  typography: {
    fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
  },
};
